import React from "react";

export const TOUR_DOC = [
    {
        selector: "#combo_aseg",
        content: "Para poder cargar documentos primero debes seleccionar una aseguradora.",
    },
    {
        selector: "#combo_titular",
        content: "Una vez seleccionada la aseguradora se cargarán los titulares, selecciona un titular.",
    },
    {
        selector: "#combo_paciente",
        content:
            "Una vez seleccionado el titular se cargarán los pacientes, selecciona un paciente y lee detenidamente las instrucciones para subir un documento o varios documentos.",
    },
    {
        selector: `btn-help-documentos`,
        content: () => <EndTour type={"documentos"} />,
    },
];

export const TOUR_DOC_VAM = [
    {
        selector: "#combo_aseg_vam",
        content: "Para poder cargar documentos primero debes seleccionar una aseguradora.",
    },
    {
        selector: "#combo_paciente_vam",
        content:
            "Una vez seleccionada la aseguradora se cargarán los pacientes, selecciona un paciente y lee detenidamente las instrucciones para subir un documento o varios documentos.",
    },
    {
        selector: `btn-help-documentos-vam`,
        content: () => <EndTour type={"documentos-vam"} />,
    },
];

export const EndTour = ({ type }) => {
    const saveEnd = () => {
        // close tour
        document.getElementById(`btn-help-${type}`).click();
    };

    return (
        <div>
            <h1>Guía terminada</h1>
            <p>
                Has terminado la guía. Si quieres volver a mostrarla en cualquier momento pulsa en el ícono:
                <i className="fas fa-question-circle" />
            </p>
            <div className={"text-center"}>
                <button onClick={saveEnd} className={"btn btn-primary"}>
                    Cerrar
                </button>
            </div>
        </div>
    );
};
